import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DashboardOutlined } from '@material-ui/icons';
import ListingMarginVendor from 'components/ListingMarginVendor';
import MasterPage from 'components/MasterPage';
import { api } from 'services';

const MarginVendor = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, vendor: '', fiscal_year: '', period: '' };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [], vendor: [], data_export: [] });
  const [fiscalYears, setFiscalYears] = useState([]);
  const [periodTypes, setPeriodTypes] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    var btn_export = document.getElementById('btn-to-excel');
    if (btn_export != null) {
      btn_export.disabled = true;
    }
    api
      .get('companies/with-marketing-plan', { params: { ...filters } })
      .then(({ data }) => setReports(data));

    api
      .get('company-rules/fiscal-years')
      .then(({ data }) => setFiscalYears(data));

    api.get('period-types').then(({ data }) => setPeriodTypes(data));

  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {

    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">Margem Por Fabricante</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <ReactHTMLTableToExcel
                  id="btn-to-excel"
                  className="login-btn mr-1 btn btn-primary-login btn-sm"
                  sheet="Report Margin Vendors"
                  filename="Report Margin Vendors"
                  table="table-to-xls"
                  buttonText={t('label:export')}
                ></ReactHTMLTableToExcel>
              </Col>
            </Row>
            <Row className="mt-5">
              <Col>
                <ListingMarginVendor
                  reports={reports}
                  filters={[
                    {
                      name: 'fiscal year',
                      key: 'fiscal_year',
                      options: fiscalYears.map(({ fiscal_year }) => {
                        return { label: fiscal_year, value: fiscal_year };
                      })
                    },
                    {
                      name: 'period',
                      key: 'period',
                      options: (() => {
                        const will_return = [];

                        periodTypes.forEach(periodType => {
                          periodType.periods.forEach(period => {
                            will_return.push({
                              label: `${periodType.name} ${period.position}`,
                              value: `${periodType.name} ${period.position}`
                            });
                          });
                        });

                        return will_return;
                      })()
                    },
                  ]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(MarginVendor);
